export enum ArchitectLeadSource {
    MULTILEAD = "Multilead"
}
export enum ArchitectLeadSource {
    MULTILEAD = "Multilead"
}
